import { render, staticRenderFns } from "./Help-PSU-IAR.vue?vue&type=template&id=f6480d9a&scoped=true&"
import script from "./Help-PSU-IAR.vue?vue&type=script&lang=js&"
export * from "./Help-PSU-IAR.vue?vue&type=script&lang=js&"
import style0 from "./Help-PSU-IAR.vue?vue&type=style&index=0&id=f6480d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6480d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
